import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import PatientProvider from '../../../containers/Providers/Patient';
import { RouteComponentProps, matchPath, withRouter } from 'react-router';
import {
  PatientInfoCard,
  PatientCristalCard,
  PatientValuesCard,
  PatientConditionsCard,
  PatientControlCard,
  PatientInterviewCard,
} from '../../../containers/Cards';
import CarePlanProvider from '../../../containers/Providers/CarePlan';

const PatientView = (props: RouteComponentProps) => {
  const match = matchPath<{
    organizationId: string;
    patientId: string;
  }>(props.location.pathname, {
    path: '/organization/:organizationId/patient/:patientId',
  });
  const patientId = match && match.params.patientId;
  if (!patientId) return null;
  return (
    <PatientProvider patientId={patientId}>
      <CarePlanProvider patientId={patientId}>
        <Fade>
          <Container fluid className="mt-3">
            <Row>
              <Col md={5}>
                <Row noGutters>
                  <Col className="mb-4">
                    <PatientInfoCard />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <PatientControlCard />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col className="mb-4">
                    <PatientInterviewCard />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} xl>
                    <Row>
                      <Col lg={12} xl className="mb-4">
                        <PatientCristalCard />
                      </Col>
                      <Col className="mb-4">
                        <PatientValuesCard />
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <PatientConditionsCard />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Fade>
      </CarePlanProvider>
    </PatientProvider>
  );
};

export default withRouter(PatientView);
